"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M13.5 10H9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-2h3.5v1.29c0 .45.54.67.85.35l2.29-2.29c.2-.2.2-.51 0-.71l-2.29-2.29c-.31-.31-.85-.09-.85.35zM12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1m7.73 11.58-7.19 7.22c-.35.27-.79.27-1.15 0L4.2 12.58c-.27-.36-.27-.8 0-1.16l7.19-7.22c.35-.27.79-.27 1.15 0l7.19 7.22c.36.27.36.8 0 1.16"
}), 'AssistantDirectionRounded');